import React from 'react';

import type { VideoModelOption } from '../../video-models';
import * as S from './ModelOptionMeta.styles';

/**
 * The explanation shown under a model's name inside the video-model dropdown: what it produces, its provider
 * and its rough speed. Page-local to the composer. Model name / provider / blurb are proper-noun-heavy
 * product copy (rendered raw); the structural labels run through i18n.
 */
export const ModelOptionMeta = ({
  model,
  perClip = false,
}: {
  model: VideoModelOption;
  /** Single-clip ad: quote the whole-clip time (`etaMinPerClip`) instead of the per-beat time. */
  perClip?: boolean;
}): React.ReactElement => {
  return (
    <S.Root>
      <S.Blurb raw text={model.blurb} tag="span" />
      <S.Meta>
        <S.MetaText raw text={model.provider} tag="span" />
        <S.Sep aria-hidden="true">·</S.Sep>
        {perClip ? (
          <S.MetaText text="About {{n}} min per clip" placeholders={{ n: model.etaMinPerClip }} tag="span" />
        ) : (
          <S.MetaText text="About {{n}} min per beat" placeholders={{ n: model.etaMinPerBeat }} tag="span" />
        )}
      </S.Meta>
    </S.Root>
  );
};

export default ModelOptionMeta;
